import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken,getHdToken, setHdToken, removeHdToken } from '@/utils/auth'
import {storeValue} from '@/utils/index'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: window.LS.get('language') || 'zh',
    currency: window.LS.get('currency') || 'USD',
    currency_char: window.LS.get('currency_char') || '＄',
    currency_usd_rate: window.LS.get('currency_usd_rate') || '1',
    pin: window.LS.get('pin')|| "",
    hangqing: window.LS.get('hangqing') || '1',
    token: getToken() || "f9dcef975fa438be92ca7ff489c1e55b9d25adf74dc498ca051354b9c32ee0cd",
    hdtoken: getHdToken() || "",
    initInfo:{},
    userInfo:{},
    
  },
  //类似计算属性
  getters: {
    language: state => state.language,
    currency: state => state.currency,
    currency_char: state => state.currency_char,
    currency_usd_rate: state => state.currency_usd_rate,
    pin: state => state.pin,
    hangqing: state => state.hangqing,
    token: state => state.token,
    hdtoken: state => state.hdtoken
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      window.LS.set('language', language)
    },
    SET_CURRENCY: (state, currency) => {
      state.currency = currency
      window.LS.set('currency', currency)
    },
    SET_CURRENCY_CHAR: (state, currency_char) => {
      state.currency_char = currency_char
      window.LS.set('currency_char', currency_char)
    },
    SET_CURRENCY_USD_RATE: (state, currency_usd_rate) => {
      state.currency_usd_rate = currency_usd_rate
      window.LS.set('currency_usd_rate', currency_usd_rate)
    },
    SET_PIN: (state, pin) => {
      state.pin = pin
      window.LS.set('pin', pin)
      storeValue(JSON.stringify({'key':'pin','value':pin}))
    },
    SET_HANGQING: (state, hangqing) => {
      state.hangqing = hangqing
      window.LS.set('hangqing', hangqing)
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    REMOVE_TOKEN: (state) => {
      state.token = ''
      removeToken()
    },
    SET_HD_TOKEN: (state, hdtoken) => {
      state.hdtoken = hdtoken
      setHdToken(hdtoken)
    },
    REMOVE_HD_TOKEN: (state) => {
      state.hdtoken = ''
      removeHdToken()
    },
    SET_INIT_INFO: (state, data) => {
      state.initInfo = data
    },
    SET_USER_INFO: (state, data) => {
      state.userInfo = data
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setPin({ commit }, pin) {
      commit('SET_PIN', pin)
    },
    setHangqing({ commit }, hangqing) {
      commit('SET_HANGQING', hangqing)
    },
    setCurrency({ commit }, currency) {
      commit('SET_CURRENCY', currency)
    },
    setCurrency_char({ commit }, currency_char) {
      commit('SET_CURRENCY_CHAR', currency_char)
    },
    setCurrency_usd_rate({ commit }, currency_usd_rate) {
      commit('SET_CURRENCY_USD_RATE', currency_usd_rate)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setInitInfo({ commit }, data) {
      commit('SET_INIT_INFO', data)
    },
    setUserInfo({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    removeToken({ commit }) {
      commit('REMOVE_TOKEN')
    },
    setHdToken({ commit }, Hdtoken) {
      commit('SET_HD_TOKEN', Hdtoken)
    },
    removeHdToken({ commit }) {
      commit('REMOVE_HD_TOKEN')
    },
  }
})
